function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_5_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M374.07,326.221c-60.435-21.791-79.744-40.18-79.744-79.543c0-4.342,0.625-7.617,1.691-10.352 c4.743-12.161,18.245-13.512,24.857-48.836c3.365-17.954,19.663-0.292,22.779-41.27c0-16.328-8.897-20.392-8.897-20.392 s4.52-24.173,6.292-42.771C343.246,59.881,327.517,0,243.638,0c-0.362,0-0.704,0.02-1.058,0.025 C242.223,0.019,241.882,0,241.516,0c-83.878,0-99.604,59.881-97.409,83.057c1.771,18.598,6.294,42.771,6.294,42.771 s-8.897,4.063-8.897,20.392c3.12,40.978,19.417,23.315,22.779,41.27c6.613,35.324,20.119,36.675,24.86,48.836 c1.064,2.734,1.689,6.01,1.689,10.352c0,39.363-19.313,57.752-79.747,79.543c-60.62,21.859-87.884,44.15-87.884,59.354 c0,15.182,0,99.583,0,99.583h219.227h0.302h219.227c0,0,0-84.401,0-99.583C461.957,370.371,434.697,348.08,374.07,326.221z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgMan = function SvgMan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "485.158px",
    height: "485.157px",
    viewBox: "0 0 485.158 485.157",
    style: {
      enableBackground: "new 0 0 485.158 485.157"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/man.bac931e0.svg";
export { ForwardRef as ReactComponent };